import { apiClient } from './ApiClient';
export const prototypesApi = {
    async list() {
        const response = await apiClient.get('/prototypes');
        return response.data.prototypes;
    },
    async get(id) {
        const response = await apiClient.get(`/prototypes/${id}`);
        return response.data.prototype;
    },
    async register(data) {
        const response = await apiClient.post('/prototypes', data);
        return response.data.prototype;
    },
    async deploy(id) {
        const response = await apiClient.post(`/prototypes/${id}/deploy`);
        return response.data;
    },
    async delete(id) {
        await apiClient.delete(`/prototypes/${id}`);
    },
    async getHealthSummary() {
        const response = await apiClient.get('/dashboard/health-summary');
        return response.data;
    },
    async checkHealth(id) {
        const response = await apiClient.get(`/prototypes/${id}/health`);
        return response.data.healthCheck;
    },
    async reset(id) {
        const response = await apiClient.post(`/prototypes/${id}/reset`);
        return response.data;
    },
    async validateRepository(githubRepoUrl) {
        const response = await apiClient.post('/prototypes/validate', {
            githubRepoUrl,
        });
        return response.data;
    },
};
